import { passwordRegex } from '@finn/ua-auth';
import { z } from 'zod';

export const emailSchema = z
  .string()
  .min(1, 'Bitte geben Sie Ihre E-Mail-Adresse ein.')
  .email('Bitte geben Sie eine gültige E-Mail-Adresse ein.');

export const passwordSchema = z
  .string()
  .min(1, 'Bitte geben Sie ein Passwort ein.')
  .min(8, 'Das Passwort muss mindestens 8 Zeichen lang sein.')
  .regex(/[a-zA-Z]/, 'Das Passwort muss mindestens einen Buchstaben enthalten.')
  .regex(/\d/, 'Das Passwort muss mindestens eine Zahl enthalten.');

export { passwordRegex };
